(function() {

    'use strict';

    angular.module('app').
    controller('RouteDetailsController', RouteDetailsController);

    RouteDetailsController.$inject = [
        '$scope',
        '$routeParams',
        '$timeout',
        '$location',
        'toastr',
        'FleetService',
        'JobsTableService',
        'RouteWaypointTable',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        'Units',
        '$rootScope',
        'hasDuplicate',
        'ClientsListsRepositoryFactory',
        'ClientService',
        '$q',
        '$filter'
    ];

    function RouteDetailsController(
        $scope,
        $routeParams,
        $timeout,
        $location,
        toastr,
        FleetService,
        JobsTableService,
        RouteWaypointTable,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        Units,
        $rootScope,
        hasDuplicate,
        ClientsListsRepositoryFactory,
        ClientService,
        $q,
        $filter
    ) {
        const vm = this;
        vm.measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next, current, test) {
            if(!vm.viewMode && isDataChanged(vm.route, vm.routeRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });
        const notAvailableOption = {
            areaId: 'N/A',
            id: null
        };

        let waypointsTable = null;
        vm.id = $routeParams.id;
        vm.viewMode = false;
        vm.isUnique = isUnique;
        vm.clientsLists = ClientsListsRepositoryFactory;

        vm.searchArea = searchArea;
        vm.searchOffice = searchOffice;
        vm.changeStatus = changeStatus;
        vm.deleteRoute = deleteRoute;
        vm.save = save;

        (()=>{
            getAvailableOffices().then(success=>{
                vm.searching = false;
                vm.clientsLists.lists.locations.content = success;
            }, error=>{
                vm.searching = false;
                toastr.error(error.message);
            });

            if(vm.id){
                vm.isFetching = true;
                FleetService.Routes.getRoute(vm.id, data=>{
                    initRoute(data);
                    vm.isFetching = false;
                }, error=>{
                    toastr.error('Route not found', error.message);
                    vm.isFetching = false;
                });
            }else{
                initRoute({});
            }
        })();

        function isUnique(model) {
            if (!model) {
                return;
            }
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.Routes.getRoutes,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model.toLowerCase(),
                compareBy: 'code',
                raw: (angular.getObjVal(vm, 'routeRaw.code') || '').toLowerCase(),
                ignoreCase: true,
                warningMsg: 'Route Code is already taken',
                filters: {
                    size: 2,
                    code: model
                }
            }).then(res => {
                vm.codeError = !!res;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

        function searchArea(select) {
            if(!select.open)
                return false;
            vm.searching = true;
            vm.areas = [];
            FleetService.Areas.getAll(data=>{
                vm.areas = data.content || [];
                vm.searching = false;
            }, error=> {
                vm.searching = true;
                toastr.error('Unable to search for area', error.message);
            }, {
                name: select.search
            })
        }

        function searchOffice(select) {
            if(!select.open) {return false;}
        }
        function getAvailableOffices(){
            var deffered = $q.defer();
            ClientService.Client.getAvailableOffice(success=>{
                deffered.resolve(success);
            }, error=>{
                deffered.reject(error);
            }, {});
            return deffered.promise;
        }
        function initRoute(data) {
            vm.route = angular.extend(data,{
                area: data.area || null,
                maxDivergenceDistance: data.maxDivergenceDistance
            });
            vm.routeRaw = angular.copy(data);
            initWaypointTable(vm.route);
            initRouteJobsTable(vm.route);

        }

        function initWaypointTable(route) {
            waypointsTable = new RouteWaypointTable(route);
            vm.waypointsTable = waypointsTable.tableData;
        }
        function initRouteJobsTable(route) {
            vm.routeJobsTable = new JobsTableService({route, referrer: 'route'}).tableData;
        }
        function changeStatus(event, active) {
            event.preventDefault();
            if (vm.route.active) {
                vm.route.active = false;
                toActiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.route.active = true;
                        });
                    }
                });
            }
            else {
                vm.route.active = true;
                toInactiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.route.active = false;
                        });
                    }
                });
            }
        }
        function isDataChanged(o, n) {
            return !angular.equals(o, n)
        }
        function cleanPayload(payload) {
            const {code, name, description, maxDivergenceDistance, active, area, office} = payload;
            return {code, name, description, maxDivergenceDistance, active,
                areaId: area.id, measureUnit: vm.measureUnit, officeId: office.id};
        }
        function save(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            if($routeParams.id){
                FleetService.Routes.updateRoute(vm.id, cleanPayload(vm.route), result=>{
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    waypointsTable.refreshTable();
                    vm.routeRaw = angular.copy(vm.route);

                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }else{
                FleetService.Routes.createRoute(cleanPayload(vm.route), result=>{
                    onRouteChange();
                    $location.path('/areas/routes/details/' + result.id);
                    toastr.success('Data successfully created');
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }
        }
        function deleteRoute() {
            deleteConf.getInstance().result.then(cond=>{
               if(cond){
                   FleetService.Routes.deleteRoute(vm.route.id, data=>{
                       toastr.success('Route successfully deleted');
                       onRouteChange();
                       $location.path('/areas/routes');
                   }, err=>{
                       toastr.error('Unable to do request. Please try again later', err.message);
                   })
               }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/routes/RouteDetailsController.js